import { useLocation, useNavigate } from 'react-router-dom';
import './ProjectDetails.css';
import Header from './Header';
import Footer from './Footer'; 

function ProjectDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const project = location.state?.project;

  if (!project) {
    return (
      <div className="project-detail-container">
        <div className="error-message">Project not found</div>
      </div>
    );
  }

  const projectNumber = String(project.id).padStart(2, '0');

  return (

    <>
    <Header/>
    <div className="project-detail-container">

      <div className="project-detail-content">

        <div className="detail-layout">
          <div className="detail-image">
            <img src={project.image} alt={project.title} />
          </div>

          <div className="detail-text">
            <h1>{project.title}</h1>
            <p>{project.fullDescription}</p>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
    </>
    
  );
}

export default ProjectDetail;
